import script from "./customerCaseDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./customerCaseDetail.vue?vue&type=script&setup=true&lang=js"

import "./customerCaseDetail.vue?vue&type=style&index=0&id=45e61fdb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45e61fdb"]])

export default __exports__